import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-lesotho-business-loan.component.scss';
import * as $ from 'jquery';
var CalculatorLesothoBusinessLoan = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorLesothoBusinessLoan, _super);
    function CalculatorLesothoBusinessLoan(element) {
        return _super.call(this, element) || this;
    }
    CalculatorLesothoBusinessLoan.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputLoanAmount = this.element.querySelector('input[name=loan_amount]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputStartDate = this.element.querySelector('input[name=start_date]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.totalMonthly = this.element.querySelector('.js-monthly');
        this.totalInterestRate = this.element.querySelector('.js-interest-rate');
        this.totalEndDate = this.element.querySelector('.js-end-date');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonView = this.element.querySelector('.js-view-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-lesotho-business-loan__result--terms');
        this.containerSchedule = document.querySelector('.js-amort-schedule-business-loan-calculator');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        $(document).ready(function () {
            // start dateppicker
            $('input.js-start-date').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            });
            var dateNew = new Date();
            var dateYear = dateNew.getFullYear();
            var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
            var dateDay = dateNew.getDate().toString().padStart(2, "0");
            // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
            var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
            $('input.js-start-date').datepicker('setDate', dateFormatted);
            $('input.js-start-date').datepicker('setStartDate', dateFormatted);
        });
        this.calculate();
        this.prePopulateDate();
    };
    CalculatorLesothoBusinessLoan.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            setTimeout(function () {
                var dateNew = new Date();
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
                var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
                $('input.js-start-date').datepicker('setDate', dateFormatted);
                $('input.js-start-date').datepicker('setStartDate', dateFormatted);
            }, 500);
        });
        // Format loan amount while typing
        this.inputLoanAmount.addEventListener('input', function (e) {
            e.target.value = _this.formatInputNumber(e.target.value);
        });
    };
    CalculatorLesothoBusinessLoan.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    CalculatorLesothoBusinessLoan.prototype.scrollHorizontally = function (event) {
        event = window.event || event;
        var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        event.currentTarget.scrollLeft -= (delta * 40); // Multiplied by 40
        event.preventDefault();
    };
    CalculatorLesothoBusinessLoan.prototype.staticHeader = function () {
        var popup = document.querySelector('.js-table-popup-modal-window');
        var table = document.querySelectorAll('.static_header');
        var tableHead = document.querySelectorAll('.static_header thead');
        var tableBody = document.querySelectorAll('.static_header tbody');
        var fixedHeader = document.querySelectorAll('.static_header .fixed');
        // const offset = table.getBoundingClientRect();
        for (var i = 0; i < table.length; ++i) {
            var offsetBody = tableBody[i].getBoundingClientRect();
            var windowOffset = popup.getBoundingClientRect();
            if (windowOffset.top >= offsetBody.top) {
                table[i].classList.add('static_header__top');
                tableHead[i].classList.add('fixed');
                if (popup.clientWidth > 767) {
                    tableHead[i].setAttribute('style', 'top: ' + ((windowOffset.top + 40) - offsetBody.top) + 'px !important;');
                }
                else {
                    tableHead[i].setAttribute('style', 'top: ' + (windowOffset.top - offsetBody.top) + 'px !important;');
                }
            }
            else {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
            if (windowOffset.top >= offsetBody.bottom) {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
        }
        if (fixedHeader != null) {
            $(tableBody).find('tr').first().children().each(function (i, e) {
                $($(fixedHeader).find('tr').children()[i]).width($(e).width() - 1);
            });
        }
    };
    CalculatorLesothoBusinessLoan.prototype.prePopulateDate = function () {
        // new date
        var todaysDay = new Date();
        var todaysDate = new Date();
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + parseFloat(this.inputTerm.value), 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var valDate = todaysDay.getDate() + " " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear();
        this.totalEndDate.innerHTML = valDate;
    };
    CalculatorLesothoBusinessLoan.prototype.calculate = function () {
        var loanAmount = parseFloat(this.inputLoanAmount.value.replace(/\s/g, ''));
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var final = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        var finalString = this.formatter(this.round(final, 0));
        this.totalMonthly.innerHTML = finalString;
        this.totalInterestRate.innerHTML = this.inputInterest.value + "%";
        // new date
        var datePartString = this.inputStartDate.value;
        var dateParts = datePartString.split("/");
        var todaysDay = new Date(dateParts[2], dateParts[1] - 1, +dateParts[0]);
        var todaysDate = new Date(dateParts[2], dateParts[1] - 1, +dateParts[0]);
        var getMonth = todaysDate.getMonth();
        todaysDate.setMonth(getMonth + parseFloat(this.inputTerm.value), 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var valDate = todaysDay.getDate() + " " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear();
        this.totalEndDate.innerHTML = valDate;
        this.calculateAmort();
    };
    CalculatorLesothoBusinessLoan.prototype.calculateAmort = function () {
        // amort array
        var amortArray = [];
        this.containerSchedule.innerHTML = '';
        // calculate month installment
        var loanAmount = parseFloat(this.inputLoanAmount.value.replace(/\s/g, ''));
        var term = parseFloat(this.inputTerm.value);
        var interestRate = parseFloat(this.inputInterest.value);
        var pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
        // amort array first line
        // let firstLine: any = {
        // 	month: 0,
        // 	payment: parseFloat(pmt),
        // 	balance: parseFloat(this.inputLoanAmount.value),
        // 	principal: '-',
        // 	interest: parseFloat(this.inputLoanAmount.value) * (interestRate / 100) / 12,
        // 	ending: '-'
        // }
        // amortArray.push(firstLine);
        // // calculate amort
        var loanStartAmount = parseFloat(this.inputLoanAmount.value.replace(/\s/g, ''));
        var loanTerm = parseFloat(this.inputTerm.value);
        var month = 0;
        for (var index = 0; index < loanTerm; index++) {
            month += 1;
            var calcMonthInterest = loanStartAmount * (interestRate / 100) / 12;
            var calcMonthPrincipal = pmt - calcMonthInterest;
            var lineItem = {
                month: month,
                loanAmount: loanStartAmount,
                installment: pmt,
                interest: calcMonthInterest,
                principal: calcMonthPrincipal,
                balance: loanStartAmount - calcMonthPrincipal
            };
            loanStartAmount = loanStartAmount - calcMonthPrincipal;
            amortArray.push(lineItem);
        }
        var totalInstallment = 0;
        var totalInterest = 0;
        var totalPrincipal = 0;
        var output = "";
        output += "<table class=\"table table--blue table-responsive table-striped static_header\"><thead><tr>\n\t\t\t\t<th>Month</th>\n\t\t\t\t<th>Payment</th>\n\t\t\t\t<th>Opening Balance</th>\n\t\t\t\t<th>Principal</th>\n\t\t\t\t<th>Interest Portion</th>\n\t\t\t\t<th>Balance</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>";
        for (var index = 0; index < amortArray.length; index++) {
            var element = amortArray[index];
            if ((index + 1) === amortArray.length) {
                output += "\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(pmt, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.principal, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.interest, 0)) + "</td>\n\t\t\t\t\t\t<td>" + this.formatter(this.round(element.balance, 0)) + "</td>\n\t\t\t\t\t</tr>\n\t\t\t\t";
                totalInterest += element.interest;
                totalPrincipal += element.loanAmount;
            }
            else {
                totalInstallment += element.installment;
                totalPrincipal += element.principal;
                if (index > 0) {
                    totalInterest += element.interest;
                    output += "\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(pmt, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.principal, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.interest, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.balance, 0)) + "</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t";
                }
                else {
                    output += "\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>" + element.month + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(pmt, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.loanAmount, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.principal, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.interest, 0)) + "</td>\n\t\t\t\t\t\t\t<td>" + this.formatter(this.round(element.balance, 0)) + "</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t";
                }
            }
        }
        output += "</tbody>\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Total</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalInstallment, 0)) + "</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalPrincipal, 0)) + "</th>\n\t\t\t\t\t<th>-</th>\n\t\t\t\t\t<th>" + this.formatter(this.round(totalInterest, 0)) + "</th>\n\t\t\t\t\t<th>-</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t</table>";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        this.containerSchedule.appendChild(docfragment);
    };
    CalculatorLesothoBusinessLoan.prototype.formatInputNumber = function (value) {
        return value
            .replace(/\s/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };
    CalculatorLesothoBusinessLoan.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorLesothoBusinessLoan.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorLesothoBusinessLoan.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorLesothoBusinessLoan;
}(Base));
export { CalculatorLesothoBusinessLoan };



//////////////////
// WEBPACK FOOTER
// ./components-lesotho/calculator-lesotho-business-loan/calculator-lesotho-business-loan.component.ts
// module id = 645
// module chunks = 0